import { PublicParams } from '@shared/utils/publicParams';
import { Injectable } from '@angular/core';
import {
    HttpInterceptor,
    HttpRequest,
    HttpHandler,
    HttpEvent,
    HttpHeaders,
} from '@angular/common/http';
import { Observable } from 'rxjs';


/**
 * 拦截器，其注册细节见 `app.module.ts`
 */
@Injectable()
export class ThirdParamInterceptor implements HttpInterceptor {

    intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
        const thirdParamValue = sessionStorage.getItem(PublicParams.thirdParam);
        if (null != thirdParamValue) {
            const newReq: HttpRequest<any> = req.clone({
                headers: new HttpHeaders().append(PublicParams.thirdParam, thirdParamValue).append('token', sessionStorage.getItem("token"))
            });
            return next.handle(newReq);
        } else {
            return next.handle(req);
        }
    }
}
